import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrgService {

  constructor(private http: HttpClient) { }

  getAllOrgs() {
    return this.http.get<any>(
      `${environment.API_URL_ACM}/api/acmorganization`);
  }
}
